import request from '@/utils/request'

/**
 * 新增登录日志
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function loginLogAdd(data) {
  return request({
    type: 'base',
    url: 'login/log/add',
    method: 'post',
    data
  })
}
/**
 * 获取登录日志列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function loginLogListGet(data) {
  return request({
    type: 'base',
    url: 'login/log/list/get',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/LoginLog.js